const fontFamily = 'Roboto';

export const typography = {
  fontFamily,
};

export const antdTypographyConfig = {
  fontFamily,
};
